import React, { Component } from 'react';
import { connect } from 'react-redux';


export class MapaVeiculoAgendamentoViagem extends Component {

    // eslint-disable-next-line class-methods-use-this
    exibirCorredor(fileira) {
        return (fileira.exibeCorredor ? <div className="transport-meio-corredor" key={`corredor-${fileira.id}`} /> : '')
    }

    // eslint-disable-next-line class-methods-use-this
    exibirFileira(fileira) {
        if (fileira.assentos.length > 0) {
            return (
                <div className="transport-meio-fileira" key={`fileira-${fileira.numero}-${this.props.andar}`}>
                    {this.exibirAssentos(fileira)}
                    <label htmlFor="_" className="transport-meio-assento espaco-vago" key='meio6'>_</label>
                </div>
            )
        }
    }

    exibirAssentos(fileira) {
        return fileira.assentos.map(assento => <div key={`assento-${this.props.sentido}-${fileira.numero}-${assento.ordem}`}>
            {this.props.bloqueio ? this.exibirAssentoBloqueio(assento, fileira) : this.exibirAssento(assento, fileira)}
        </div>)
    }

    exibirAssento(assento, fileira) {
        const { poltrona } = assento;
        if (assento.tipoAssento !== 'NORMAL') {
            return <label key={assento.id} className="espaco-vago  js-seat-selected-amplitude"></label>
        }

        if (!poltrona || poltrona.agendamentoViagemComPassageiro) {
            return <label data-toggle="tooltip" data-html="true" key={assento.id} className="assento assento-ocupado">{poltrona.numero}</label>
        }

        return (
            <label key={assento.id} style={!assento.selecionado ? !poltrona.reservada && poltrona.reservas && poltrona.reservas.length ? {
                backgroundColor: '#2b4ec6',
                color: '#FFF'
            } : {
                backgroundColor: '#02c659',
                color: '#FFF'
            } : null}
                className={`assento assento-disponivel  js-seat-selected-amplitude ${assento.selecionado ? assento.ehBloqueado ? 'assento-bloqueado' : 'assento-selecionado' : ''}`}>
                {poltrona.numero}
                <input data-toggle="tooltip" data-html="true"
                    onClick={() => {
                        this.selecionarEMarcarPoltrona(assento, fileira);
                        if (document.querySelectorAll('[role="tooltip"]')[0]) {
                            document.querySelectorAll('[role="tooltip"]')[0].remove();
                        }
                    }}
                    value={poltrona.numero} />

            </label>
        )
    }

    selecionarEMarcarPoltrona(assento, fileira) {
        this.props.selecionar(assento, fileira)
    }

    exibirAssentoBloqueio(assento, fileira) {
        const { poltrona } = assento;
        if (assento.tipoAssento !== 'NORMAL') {
            return <label key={assento.id} className="espaco-vago  js-seat-selected-amplitude"></label>
        }
        return (
            <label key={assento.id}
                className={'assento assento-disponivel  js-seat-selected-amplitude'}
                style={{
                    backgroundColor: assento.selecionado ? 'green' : poltrona.bloqueada ? 'red' : '',
                    color: poltrona.bloqueada || assento.selecionado ? 'white' : ''
                }}>
                {poltrona.numero}
                <input type="checkbox" name={poltrona.id} id={poltrona.id} data-assento={poltrona.numero}
                    onClick={() => this.selecionarEMarcarPoltrona(assento, fileira)}
                    value={poltrona.numero} />

            </label>
        )
    }

    exibirMapaVeiculo() {
        if (this.props.mapaVeiculo && this.props.mapaVeiculo.length) {
            return (this.props.mapaVeiculo.map(fileira => <React.Fragment key={fileira.id}>
                <div>
                    {this.exibirFileira(fileira)}
                </div>
                {this.exibirCorredor(fileira)}
            </React.Fragment>))
        }
    }

    render() {
        return (
            <>
                <div className="transport-result-wrapper transport-result-wrapper-connection " data-wrapper-direction="">
                    <div className="js-count-transport">
                        <div className="transport bus-design bus-design-side ">
                            <div className="transport-frente" />
                            <div className="transport-meio transport-meio-thin">
                                {this.exibirMapaVeiculo()}
                            </div>
                            <div className="transport-traseira" />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada
    }
}


export default connect(mapStateToProps, {})(MapaVeiculoAgendamentoViagem)